<template>
	<o-tour :ref="setup._tourTimeTicketReleaseNote">
		<o-tour-step
			title="Affichage de la souplesse"
			hide-finish
			target="toggleFlex">
			<div>
				Paramétrez l'affichage de la souplesse en cliquant sur ce bouton.
				<br>
				Cette configuration est sauvegardée, unique par
				utilisateur et se répercutera dans le détail
				des relevés par semaine !
			</div>
		</o-tour-step>

		<o-tour-step
			v-if="setup.hasData"
			title="Intégration du relevé"
			:target="setup.firstIntegratedCircle.bind(setup)">
			<div>
				Chaque relevé d'heures hebdomadaire pourra être intégré,
				afin de signifier qu'il a bien été pris en compte par l'ERP métier.
				<br>
				Vous pourrez également filtrer sur ce statut supplémentaire !
			</div>
		</o-tour-step>

		<o-tour-step
			v-else
			size="lg">
			<div>
				<p>
					Lorsque des relevés d'heures seront dématérialisés,
					ils pourront être intégrés par l'ERP métier !
					<br>Vous retrouverez les RH intégrés en <b style="color:var(--pink)">violet</b>.
				</p>
				<div
					v-if="setup.hasData === 0"
					class="row row--center">
					<p style="width:300px">
						<time-ticket-week-card
							:time-ticket="{
								weekNumber: 42,
								year: 2023,
								qtyToValidate: 5,
								qtyValidated: 10,
								qtyPending: 0,
								qtyIntegrated: 1,
							} as Armado.TimeTicketWeekYear"/>
					</p>
				</div>
			</div>
		</o-tour-step>
	</o-tour>
</template>

<script setup lang="ts">
import TourTimeTicketReleaseNoteSetupService from '@/setup/tour/TourTimeTicketReleaseNoteSetupService';
import TimeTicketWeekCard from '@/components/time-ticket/TimeTicketWeekCard.vue';
const setup = new TourTimeTicketReleaseNoteSetupService();

</script>
